import api from 'api';
import {format} from 'date-fns';
import {useMemo, useState} from 'react';
import toast from 'react-hot-toast';
import {useQuery} from 'react-query';
import {BlogResponse, ListResponse, SelectOption} from 'types';

async function getMessageTemplates() {
  const {data} = await api.get<ListResponse<BlogResponse>>(
    `/support/templates/`,
    {
      params: {content_type: 'template'},
    }
  );
  return data?.results;
}

export const useSMSModal = ({
  customerIds,
  metaDatas,
  onClose,
}: {
  customerIds: string[];
  metaDatas: any;
  onClose: () => void;
}) => {
  const [message, setMessage] = useState('');
  const [selectedTemplate, setSelectedTemplate] = useState<SelectOption>();
  const {data: messageTemplates} = useQuery(
    ['message_templates'],
    getMessageTemplates,
    {
      refetchOnWindowFocus: false,
    }
  );

  const templateOptions = useMemo(() => {
    return messageTemplates?.map((temp: BlogResponse) => ({
      label: temp?.title,
      value: temp?.content,
    }));
  }, [messageTemplates]);

  const sendMessage = async () => {
    try {
      await api.post(
        '/customers/sms/blast/',
        {
          message,
          customer_ids: customerIds,
        },
        {
          params: {
            status: 'all',
            last_offering_date_after: metaDatas.last_offering_date.startDate
              ? format(metaDatas.last_offering_date.startDate, 'yyyy-MM-dd')
              : undefined,
            last_offering_date_before: metaDatas.last_offering_date.endDate
              ? format(metaDatas.last_offering_date.endDate, 'yyyy-MM-dd')
              : undefined,
            total_offerings_range_min: metaDatas.total_offerings_range.from
              ? metaDatas.total_offerings_range.from
              : undefined,
            total_offerings_range_max: metaDatas.total_offerings_range.to
              ? metaDatas.total_offerings_range.to
              : undefined,
          },
        }
      );
      toast.success('Message sent successfully');
      onClose();
      setMessage('');
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.error('Error sending message:', error);
      }

      toast.error('Something went wrong');
    }
  };

  const handleClose = () => {
    setMessage('');
    setSelectedTemplate(undefined);
    onClose();
  };
  return {
    templateOptions,
    selectedTemplate,
    setSelectedTemplate,
    message,
    setMessage,
    sendMessage,
    handleClose,
  };
};
